import { Button, Stack } from '@mantine/core';
import { i18nKeys, useTranslation } from 'locales';
import { extractMainMailContent } from 'modules/Mails/extractMainMailContent';
import { useState } from 'react';
import { isNonNullish, isNullish } from 'remeda';
import { MailBodyFrame } from '../MailBodyFrame';
import { useThreadMessage } from './useThreadMessage';

export const ThreadMessageBody = () => {
  const { t } = useTranslation();
  const { mail } = useThreadMessage();

  const [showFullBody, setShowFullBody] = useState(false);

  const { content, hasQuotedContent } = isNullish(mail.body)
    ? { content: '', hasQuotedContent: false }
    : extractMainMailContent(mail.body);

  return (
    <Stack p="space5" gap="space3">
      {isNonNullish(mail.body) && <MailBodyFrame html={showFullBody ? mail.body : content} />}
      {hasQuotedContent && (
        <Button
          variant="subtle"
          size="compact-xs"
          color="gray"
          onClick={() => setShowFullBody(prev => !prev)}
          style={{ alignSelf: 'flex-start' }}
        >
          {showFullBody ? t(i18nKeys.EXTERNAL_MAIL.SHOW_LESS) : t(i18nKeys.EXTERNAL_MAIL.SHOW_MORE)}
        </Button>
      )}
    </Stack>
  );
};
